<template>
    <div>
         <!-- 轮播图 -->
         <div class="header">
            <div class="header-tag">Products</div>
            <div class="header-title">产品中心</div>
        </div>
        <!-- 产品中心 -->
        <div class="">
            <div class="w">
                <div class="flex-column align-center justify-center header1">
                    <div class="title">
                        控制器
                    </div>
                    <div class="sub_title">Controller</div>
                </div>
            </div>
            <div class="">
                <div class="w">
                    <div class="flex-row flex-wrap ">
       
                        <!-- <div @click="page(index)" class="products-item flex-column align-center justify-center" :class="{ 'active': index == 0 }"
                            v-for="(item, index) in controllerData">
                            <img :src="require('../../assets/img/controller/' + item.img)" style="width: 300px;height: 300px;" alt="">
                            <div class="item-name">{{item.name}}</div>
                        </div> -->
                        <div  class="products-item flex-column align-center justify-center" :class="{ 'active': index == 0 }"
                            v-for="(item, index) in controllerData">
                            <img  :ref="prefix+item.id" :src="http.ipAddress+item.filePath"
                                style="width: 300px;height: 300px;" alt=""  @click="page(item.id)">
                            <!-- <img :src="require('../../assets/img/controller/' + item.img)" style="width: 300px;height: 300px;" alt=""> -->
                            <div class="item-name">{{item.productName}}</div>
                        </div>
                    </div>
<!-- 
                    <div class="flex-row justify-center" style="padding-bottom: 30px;">
                        <div class="more">
                            >> More
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
        <!-- 智能仪表 -->
        <div class="">
            <div class="w">
                <div class="flex-column align-center justify-between header1">
                    <div class="title">
                        智能仪表
                    </div>
                    <div class="sub_title">Meter</div>
                </div>
            </div>
            <div class="">
                <div class="w">
                    <div class="flex-row flex-wrap ">
                        <!-- <div  @click="page1(index)" class="products-item flex-column align-center justify-between" :class="{ 'active': index == 0 }"
                            v-for="(item, index) in meterData">
                            <img :src="require('../../assets/img/controller/' + item.img)" style="width: 300px;height: 300px;" alt="">
                            <div class="item-name">{{item.name}}</div>
                        </div> -->
                        <div   class="products-item flex-column align-center justify-between" :class="{ 'active': index == 0 }"
                            v-for="(item, index) in meterData">
                            <!-- <img :src="require('../../assets/img/controller/' + item.img)" style="width: 300px;height: 300px;" alt=""> -->
                            <img  :ref="prefix+item.id" :src="http.ipAddress+item.filePath"
                                style="width: 300px;height: 300px;" alt="" @click="page1(item.id)" >
                            <div class="item-name">{{item.productName}}</div>
                        </div>
                    </div>

                    <!-- <div class="flex-row justify-center" style="padding-bottom: 30px;">
                        <div class="more">
                            >> More
                        </div>
                    </div> -->

                    
                </div>
            </div>
        </div>
    </div>
</template>


<script>
// import { controllerData,  meterData} from "../products/products";
export default {
    data() {
        return {
            // controllerData:controllerData,
            // meterData:meterData,
            prefix:"product",
            controllerData:[],
            meterData:[],
            keepScroll: 0
        }
    },
    methods: {
        page(index) {
            const scrollTop = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop)
            this.keepScroll = scrollTop;
            this.$router.push({path:'/productsDetail', query: {switch:1,index}});
        },
        page1(index) {
            const scrollTop = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop)
            this.keepScroll = scrollTop;
            this.$router.push({path:'/productsDetail', query: {switch:2,index}});
        }
    },
    activated() {
      var gotoScroll = this.keepScroll
      setTimeout(function(){
          //兼容 PC and Mobile 写两个
          document.body.scrollTop = gotoScroll;
          document.documentElement.scrollTop = gotoScroll;
          console.debug('set:' + gotoScroll)
      }, 10);
    },
    mounted() {
        debugger
        let that=this;
        this.http.post("/api/FJ_ProductInfo/GetAllProduct",JSON.stringify({})).then((result)=>{
            debugger
           let objResult= eval(result);
           let iCode= objResult.code;
           if(iCode==0){
                for(let i=0;i<objResult.data.length;i++){
                    if(objResult.data[i].productType==1){
                        that.controllerData.push(objResult.data[i]);
                    }
                    else if(objResult.data[i].productType==2){
                        that.meterData.push(objResult.data[i]);
                    }
                }
               // that.refs.product10.focus();
               // document.getElementById("product10").focus();

            }
        });
    }
}
</script>

<style scoped>
.header {
    background: url('../../assets/img/productbanner.jpg') no-repeat;
    background-size: 100%;
}
.products-item {
    width: 33%;
    padding: 30px;
    box-sizing: border-box;
    border: 1px solid #eee;
    margin-bottom: 30px;
    border: 1px solid transparent;
}

.products-item:hover {
    border: 1px solid #0AA00A;
}
</style>


// WEBPACK FOOTER //
// src/views/products/index.vue